<cs-header>
  <cs-header-title>{{ title }}</cs-header-title>
</cs-header>

<cs-content [loading]="loading">
  @if (exerciseNotFound) {
    <cs-info-card type="warning" [dismissible]="false">
      {{ LL.editExercise.messages.exerciseNotFound() }}
    </cs-info-card>
  }

  <!-- #4737: the database could not be read, which is NOT the same as the exercise being
       gone — saying so would send the user off to recreate one they still have. -->
  @if (exerciseUnreadable) {
    <cs-info-card type="warning" [dismissible]="false">
      {{ LL.editExercise.messages.exerciseUnreadable() }}
    </cs-info-card>
  }

  @if (isImportableExercise) {
    <cs-info-card type="info" [dismissible]="false" class="share-banner">
      {{ LL.editExercise.messages.sharedWithYou() }}
    </cs-info-card>
  } @else if (isOwnExercise) {
    <cs-info-card type="info" [dismissible]="false" class="share-banner">
      {{ LL.editExercise.messages.youOwnThisExercise() }}
    </cs-info-card>
  }

  @if (exercise) {
    <div class="form-content">
      <!-- Every field below is disabled. They are rendered as fields rather than as plain
           text so a shared exercise reads the same way as one the user owns. -->
      <div class="form-row">
        <cs-form-field [label]="LL.editExercise.labels.name()" class="name-field">
          <cs-input [(value)]="exercise.name" [placeholder]="LL.editExercise.placeholders.exerciseName()"
            autocomplete="off" [disabled]="true" />
        </cs-form-field>
        <cs-form-field [label]="LL.editExercise.labels.equipmentTemplate()" class="equipment-field">
          <cs-select [placeholder]="LL.editExercise.placeholders.selectTemplate()"
            [(value)]="exercise.equipmentTemplateId" [disabled]="true">
            <!-- template.name is a localized equipment-template display name (already
                 routed through LL by localizeEquipmentTemplates); Equipment.name itself
                 is a shared data-model field typed string, not display prose to translate here -->
            @for (template of equipmentTemplates; track template) {
              <cs-select-option [value]="template.id"
              [label]="template.name | untranslated"></cs-select-option>
            }
          </cs-select>
        </cs-form-field>
      </div>
      <!-- The advanced fields are always open here. There is nothing to expand away from:
           the read-only screen has no primary editing task to keep them out of. -->
      <div class="advanced-section">
        <div class="advanced-content">
          <div class="form-row">
            <cs-form-field [label]="LL.editExercise.labels.shortName()" class="shortname-field">
              <cs-input [(value)]="exercise.shortname"
                [placeholder]="LL.editExercise.placeholders.shortName()" autocomplete="off"
                [disabled]="true" />
            </cs-form-field>
            <cs-form-field class="bodyweight-field">
              <cs-label>{{ LL.editExercise.labels.bodyweightPercent() }}</cs-label>
              <cs-input-measure type="percent" [(canonValue)]="exercise.bw_pc"
              [disabled]="true"></cs-input-measure>
              <span class="field-hint">{{ LL.editExercise.hints.bodyweightPercent() }}</span>
            </cs-form-field>
          </div>
          <cs-form-field [label]="LL.editExercise.labels.videoUrl()" class="video-url-field">
            <cs-input [(value)]="exercise.videoUrl" [placeholder]="LL.editExercise.placeholders.videoUrl()"
              autocomplete="off" [disabled]="true" />
          </cs-form-field>
          <cs-form-field [label]="LL.editExercise.labels.instructions()" class="description-field">
            <cs-textarea [placeholder]="LL.editExercise.placeholders.instructions()"
              [(value)]="exercise.description" [disabled]="true" />
          </cs-form-field>
        </div>
      </div>
    </div>
  }
</cs-content>

@if (isImportableExercise) {
  <cs-page-action-buttons>
    <cs-button primary medium [label]="LL.editExercise.buttons.importExercise()"
      (click)="handleImportExercise($event)"></cs-button>
  </cs-page-action-buttons>
}
